<script lang="ts">
  import type { FacetValueGroup, FacetValueGroupOptions } from "./type.ts";
  import Box from "./Box.svelte";

  interface Props extends FacetValueGroup, FacetValueGroupOptions {
    withExpander?: boolean;
  }

  let { values = [], title, item, containsRanges, valueStatus, withExpander = false }: Props = $props();
</script>

<Box {values} {title} {valueStatus} {item} {containsRanges} {withExpander} wrap={true} horizontalScroll={false} />
